<template>
     <div>
        <h1 v-cloak class="text-center" style="margin: 50px 0 20px;">{{MainTitle}}</h1>
        <div class="row">
            <div v-for="(item, index) in menu" 
                    v-bind:class="renderLayout(index)"
                     v-on:mouseover="mouseOver(index)"
                     v-on:mouseleave="mouseLeave()">

                    <app-block :block="item"/>

                    <subscription :block="item"/>

            </div>
        </div>
     </div>
</template>


<script>
    import appBlock from './blockGroup.vue';
    import subscription from './subscription.vue';
    import axios from '../services/axiosClient';

    export default {
        components: {
            appBlock,
            subscription
        },
        data: function () {
            return {
                menu: {},
                login: false,
                boostrapClass: "col-md-3 smi-block",
                layoutName: "",
            };
        },
        async created() {
            var self = this;

            try{
                var getConfig = await axios.get('/api/Hubs/GetConfig');
                var response = getConfig.data;
                
                self.menu = response.Menus;
                var layout =response.Layout;
                self.layout = layout;
                self.MainTitle = layout.MainTitle;
                self.PageTitle = layout.PageTitle;
                self.layoutName = layout.name;
                this.assignContactLinkToEachBlock(response.Contact);

                self.login = true;
            }
            catch(err){
                 self.login = false;
            }   
        },
        methods: {
            assignContactLinkToEachBlock: function(contactURL){
                this.menu.forEach(element => {
                    element.contact = contactURL;
                });
            },
            getInActiveClass: function (active) {
                if (!active) {
                    return 'unallow';
                }
                return 'allow';
            },
            
            goToContact: function (linkContact) {
                window.open(linkContact, '_blank');
            },

            mouseOver: function (index) {
                this.menu[index].Show = true;
                for (var i = 0; i < this.menu.length; i++) {
                    if (i !== index) {
                        this.menu[i].Show = false;
                    }
                }
            },
            mouseLeave: function () {
                for (var i = 0; i < this.menu.length; i++) {
                    this.menu[i].Show = false;
                }
            },
            mouseleavetooltip: function () {
                this.mouseLeave();
            },
            mouseovertooltip: function (index) {
                this.mouseOver(index);
            },
            
            defaultViewClick: function (index) {
                this.menu[index].DefaultView = !this.menu[index].DefaultView;
            },

            showLoginPopup: function () {

            },
            renderLayout: function (index) {
                var columns = this.layout.Columns;
                if (this.layout.Name.toLowerCase() == 'brightness') {
                   return this.brightnessLayout(columns);
                }
                else {
                    return this.darknessLayout(columns, this.menu.length, index);
                }
            },

            brightnessLayout:(col)=>{
                return col === 3? "col-md-4 smi-block": "col-md-3 smi-block";
            },
            darknessLayout:(col, len, index)=>{

                if(col === 3){
                    if (len % 3 == 1) {
                        if (index == len - 1) {
                            return "col-md-offset-4 col-md-4 smi-block";
                        }
                    }
                    if (len % 3 == 2) {
                        if (index == len - 2) {
                            return "col-md-offset-2 col-md-4 smi-block";
                        }
                    }
                    return "col-md-4 smi-block";
                }
                return col === 3? "col-md-4 smi-block": "col-md-3 smi-block";   
            }
        },

        

        watch: {
            login: function (newValue) {
                if (newValue) {
                    this.$emit('showLoading', false);
                } else {
                    this.$emit('showLoading', true);
                }
            }
        }
    };
</script>